// smartie-frontend/src/services/analyticsService.ts

// This ensures TypeScript knows about the gtag function on the window object.
declare global {
  interface Window {
    gtag?: (
      command: "event",
      eventName: string,
      eventParams?: {
        [key: string]: string | number | boolean | undefined | null;
      },
    ) => void;
  }
}

/**
 * Tracks a custom event using Google Analytics 4's gtag.
 * Safely checks if the gtag function is available on the window object.
 * This approach is robust and works even if GA is loaded by another plugin
 * like PixelYourSite, or if it's blocked by an ad blocker.
 *
 * @param {string} eventName The name of the event to track (e.g., 'widget_opened').
 * @param {object} [eventParams] Optional parameters to send with the event.
 */
export const trackEvent = (
  eventName: string,
  eventParams?: { [key: string]: string | number | boolean | undefined | null },
): void => {
  // Check if window.gtag is a function before calling it.
  if (typeof window.gtag === "function") {
    try {
      window.gtag("event", eventName, eventParams);
    } catch (error) {
      // Use our own logger if we have one, otherwise console.error
      console.error("Error sending GA event:", error);
    }
  }
  // No 'else' block needed to log a warning, as it's common for GA to be blocked.
};
